<template>
    <div class="app-container">
      <!-- 顶部四个数据统计模块 :class="{ 'card-danger': statistics.exceptionCount > 0 }"-->
      <div class="statistics-container">
        <div class="statistic-card card-danger">
          <div class="statistic-value" style="color:#f56c6c">{{topData.exceptionTotal}}</div>
          <div class="statistic-label">{{ $t('ExternalOrders.page.exceptionLabel') }}</div>
        </div>
        <div class="statistic-card card-primary">
          <div class="statistic-value">{{topData.processingTotal}}</div>
          <div class="statistic-label">{{ $t('ExternalOrders.page.processingLabel') }}</div>
        </div>
        <div class="statistic-card card-success">
          <div class="statistic-value">{{topData.writeBackTotal}}</div>
          <div class="statistic-label">{{ $t('ExternalOrders.page.processingStatusWriteback') }}</div>
        </div>
        <div class="statistic-card card-gray">
          <div class="statistic-value">{{topData.unCapturedTotal}}</div>
          <div class="statistic-label">{{ $t('ExternalOrders.page.processingStatusUncaptured') }}</div>
        </div>
      </div>
      <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :col-span="colSpan" :before-reset-search="beforeResetSearch" @afterFetchOriginalData="afterFetchOriginalData" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col v-if="!$store.getters.cusId" :span="colSpan">
            <el-form-item :label="$t('BusinessAfterCsgReturn.table.cusName')">
              <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('customerNameText')" @change="handleClientCodeChange"/>
            </el-form-item>
          </el-col>
          <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-keys="['channelTypeCode', 'storeId']" @handleChannelChange="handleChannelChange" @handleStoreChange="handleStoreChange" />
          <el-col :span="colSpan">
            <el-form-item :label="$t('ExternalOrders.page.orderIdLabel')" prop="orderId">
              <BjInput v-model="queryParams.orderId" :placeholder="$t('ExternalOrders.page.orderIdLabel')" @keyup.enter.native="handleQuery" :disabled="!queryParams.channelTypeCode" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('ExternalOrders.page.orderStatusLabel')" prop="orderStatus">
              <el-select v-model="queryParams.orderStatus" :placeholder="$t('ExternalOrders.page.orderStatusLabel')" class="full-width" clearable :disabled="!queryParams.channelTypeCode">
                  <el-option v-for="item in orderStatusList" :key="item.label" :label="item.label" :value="item.value">
                      <span>{{ item.label }}</span>
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('ExternalOrders.page.processingStatusLabel')" prop="processingStatus">
              <BjSelectLov v-model="queryParams.processingStatus" :placeholder="$t('ExternalOrders.page.processingStatusLabel')" :option-list="PROCESSING_STATUS_LIST" :disabled="!queryParams.channelTypeCode" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('ExternalOrders.page.eligibleLabel')" prop="eligible">
              <BjSelectLov v-model="queryParams.eligible" :placeholder="$t('ExternalOrders.page.eligibleLabel')" :option-list="ELIGIBLE_LIST" :disabled="!queryParams.channelTypeCode" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="col.prop == 'clientCode'">{{ clientCodeList.bjGet(scope.row.clientCode) }}</template>
                <el-tag v-else-if="col.prop === 'orderStatus'" :type="scope.row.orderStatus=='open' ? 'success' : 'info'">{{ scope.row.orderStatus }}</el-tag>
                <el-tag v-else-if="col.prop === 'paymentStatus'" :type="scope.row.paymentStatus=='paid' ? 'success' : 'info'">{{ scope.row.paymentStatus ? scope.row.paymentStatus : 'N/A' }}</el-tag>
                <el-tag v-else-if="col.prop === 'processingStatus'" :type="scope.row.processingStatus!='Exception' ? 'success' : 'info'">{{ $t(PROCESSING_STATUS_LIST.bjGet(scope.row.processingStatus)) }}</el-tag>
                <el-tag v-else-if="col.prop === 'eligible'" :type="scope.row.eligible=='Yes' ? 'success' : 'info'">{{ scope.row.eligible }}</el-tag>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button v-if="props.row.processingStatus == 'Exception'" type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button v-if="props.row.processingStatus == 'Exception'" type="text" class="delete-btn" @click="onRetry(props.row)">{{ $t('ExternalOrders.page.retryBtn') }}</el-button>
                <el-button v-if="props.row.processingStatus == 'Uncaptured'" type="text" class="delete-btn" @click="onPull(props.row)">{{ $t('ExternalOrders.page.pullBtn') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 异常确认框 -->
      <el-dialog
        :visible.sync="exceptionDialogVisible"
        width="600px"
        :close-on-click-modal="false"
        class="exception-dialog"
      >
        <span slot="title">
          <i class="el-icon-warning" style="color: #f56c6c; margin-right: 6px;"></i>
          <span style="font-size: 16px; font-weight: 600;">{{ $t('ExternalOrders.page.dialogTitle') }}</span>
        </span>
        <div class="exception-content">
          <div class="exception-title">
            <span>Order {{ currentRow.platformOrderNo }} — {{ clientCodeList.bjGet(currentRow.clientCode) }}</span>
          </div>
          <div class="exception-message">
            <div class="message-label">{{ $t('ExternalOrders.page.errorMessageLabel') }}</div>
            <div class="message-text">{{ currentRow.exceptionReason }}</div>
          </div>
          <div class="exception-tip">
            {{ $t('ExternalOrders.page.dialogTip') }}
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exceptionDialogVisible = false">{{ $t('ExternalOrders.page.closeBtn') }}</el-button>
          <el-button type="primary" @click="handleRetryFromDialog">{{ $t('ExternalOrders.page.retryBtn') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { waveApi } from '@/api'; 

  export default {
    name: 'BusinessChannelOnlineCsgAdmin',
    components: { },
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        queryApi: waveApi.getOrdersList,
        // 查询参数
        queryParams: {
          clientCode: this.$store.getters.userInfo.clientCode || null,
          cusId: this.$store.getters.cusId || null,
          channelTypeCode: '3', // 渠道编码（供 BjSelectChannelStore 内部店铺联动使用）
          channel: "Shopify (legacy)",   // 渠道名称（传给列表查询接口和订单状态接口）
          storeCode: null,
          storeId: null,
          orderId: null,
          orderStatus: null,
          processingStatus: null,
          eligible: null,
        },
        labelList: [
          { label: this.$t('ExternalOrders.page.orderIdLabel'), prop: 'platformOrderNo', isCheck: true, disabled: false, },
          { label: this.$t('ExternalOrders.page.orderStatusLabel'), prop: 'orderStatus', isCheck: true, disabled: false, },
          { label: this.$t('ExternalOrders.page.fulfillmentLabel'), prop: 'fulfillmentStatus', isCheck: true, disabled: false, },
          { label: this.$t('ExternalOrders.page.paymentStatusLabel'), prop: 'paymentStatus', isCheck: true, disabled: false, },
          { label: this.$t('ExternalOrders.page.warehouseLabel'), prop: 'warehouseName', isCheck: true, disabled: false, },
          { label: this.$t('ExternalOrders.page.eligibleLabel'), prop: 'eligible', isCheck: true, disabled: false, },
          { label: this.$t('ExternalOrders.page.processingStatusLabel'), prop: 'processingStatus', isCheck: true, disabled: false, },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 }
        ],
        topData:{},
        orderStatusList:[],
        PROCESSING_STATUS_LIST:[
          {label: this.$t('ExternalOrders.page.processingStatusException'), value:'Exception'},
          {label: this.$t('ExternalOrders.page.processingStatusProcessing'), value:'Processing'},
          {label: this.$t('ExternalOrders.page.processingStatusWriteback'), value:'Writeback'},
          {label: this.$t('ExternalOrders.page.processingStatusUncaptured'), value:'Uncaptured'},
        ],
        ELIGIBLE_LIST:[
          {label:'Yes', value:'Yes'},
          {label:'No', value:'No'},
        ],
        // 异常对话框相关
        exceptionDialogVisible: false,
        currentRow: {},
      };
    },
    created(){
      // 获取顶部信息
      this.getOrdersNum(this.queryParams)
      // 获取外部平台订单状态
      this.getOrdersStatus()
    },
    methods: {
      // 获取顶部信息
      getOrdersNum(queryParams){
        waveApi.getOrdersNum(queryParams).then(res=>{
          if(res.code == 200 || res.msg == "SUCCESS"){
            this.topData = res.data
          }
        })
      },
      // 获取外部平台订单状态
      getOrdersStatus(){
        waveApi.getOrdersStatus(this.queryParams).then(res=>{
          if(res.code == 200 || res.msg == "SUCCESS"){
            this.orderStatusList = res.data.map(item => {
              return { label: item, value: item } 
            })
          }
        })
      },
      // 客户变更时调用
      handleClientCodeChange(v, item) {
        this.queryParams.cusId = item ? item.cusId : null
        // 清空渠道和店铺相关字段
        this.queryParams.channelTypeCode = null
        this.queryParams.channel = null
        this.queryParams.storeId = null
        this.queryParams.storeCode = null
        // 清空其他查询条件
        this.queryParams.orderId = null
        this.queryParams.orderStatus = null
        this.queryParams.processingStatus = null
        this.queryParams.eligible = null
        // 重新获取订单状态
        this.getOrdersStatus()
      },
      // 渠道变更时调用
      handleChannelChange(v, item){
        // channel 传渠道名称给列表查询接口和订单状态接口（channelTypeCode 由 BjSelectChannelStore 内部 v-model 维护）
        this.queryParams.channel = item ? item.label : null
        // 清空店铺相关字段（BjSelectChannelStore 内部已清空 storeId）
        this.queryParams.storeCode = null
        // 渠道变更后重新获取对应渠道的订单状态
        this.getOrdersStatus()
        // 清空其他查询条件
        this.queryParams.orderId = null
        this.queryParams.orderStatus = null
        this.queryParams.processingStatus = null
        this.queryParams.eligible = null
      },
      // 店铺传参使用
      handleStoreChange(n,m){
        this.queryParams.storeCode = m.code
        // 渠道店铺变更后重新获取对应渠道店铺的订单状态
        this.getOrdersStatus()
        // 清空其他查询条件
        this.queryParams.orderId = null
        this.queryParams.orderStatus = null
        this.queryParams.processingStatus = null
        this.queryParams.eligible = null
      },
      /** 查看 - 打开异常确认框 */
      onView(row) {
        this.currentRow = row;
        this.exceptionDialogVisible = true;
      },
      /** 从对话框中执行重试 */
      handleRetryFromDialog() {
        this.exceptionDialogVisible = false;
        this.onRetry(this.currentRow);
      },
      /** 订单重试 */
      onRetry(row) {
        waveApi.retryOrders({ orderNo: row.platformOrderNo, storeCode: row.storeCode }).then(res => {
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      },
      /** 订单抓取 */
      onPull(row) {
        waveApi.pullOrders({ orderNo: row.platformOrderNo, storeCode: row.storeCode }).then(res => {
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }else if(res.code == 400){
            this.msgError(res.msg);
          }
        });
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParams.clientCode = this.$store.getters.userInfo.clientCode || null;
        // 清空客户ID
        this.queryParams.cusId = this.$store.getters.cusId || null;
        // 清空渠道和店铺
        this.queryParams.channelTypeCode = '3';
        this.queryParams.channel = "Shopify (legacy)";
        this.queryParams.storeId = null;
        this.queryParams.storeCode = null;
        this.getOrdersNum(this.queryParams)
        return new Promise(resolve => {
          resolve();
        });
      },
      /** 处理返回数据格式 */
      afterFetchOriginalData(res) {
        // 优化列表页数据
        if (res) {
          res.content = res.records || [];
          res.totalElements = Number(res.total) || 0;
          res.totalPages = Number(res.pages) || 0;
        }
        this.getOrdersNum(this.queryParams)
      },
    },
  };
  </script>
  <style lang="scss" scoped>
    ::v-deep .bj-page .el-form-item__label {
      display: none;
    }
    // 统计卡片容器
    .statistics-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      margin-bottom: 20px;

      .statistic-card {
      background: #fff;
      border-radius: 4px;
      padding: 20px;
      border-left: 4px solid #dcdfe6;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        &.card-danger {
            border-left-color: #f56c6c;
        }

        &.card-primary {
            border-left-color: #409eff;
        }

        &.card-success {
            border-left-color: #67c23a;
        }

        &.card-gray {
            border-left-color: #909399;
        }

        .statistic-value {
            font-size: 28px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 8px;
        }

        .statistic-label {
            font-size: 14px;
            color: #909399;
        }
      }
    }

    // 异常对话框样式
    .exception-dialog {
      ::v-deep .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #ebeef5;
      }
      ::v-deep .el-dialog__body {
        padding: 20px;
      }
      ::v-deep .el-dialog__footer {
        padding: 10px 20px 20px;
        border-top: 1px solid #ebeef5;
      }
    }
    .exception-content {
      .exception-title {
        font-size: 16px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
      }
      .exception-message {
        background-color: #fef0f0;
        border: 1px solid #fbc4c4;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 16px;
        .message-label {
          color: #f56c6c;
          font-weight: 500;
          margin-bottom: 8px;
          font-size: 14px;
        }
        .message-text {
          color: #f56c6c;
          font-size: 14px;
          line-height: 1.6;
        }
      }
      .exception-tip {
        color: #606266;
        font-size: 14px;
        line-height: 1.6;
      }
    }
  </style>
